import { defineStore } from 'pinia';
import { fetchMarketingCampaignData } from './services/api';
import { MarketingCampaign } from '@/js/marketing-campaigns/types/types';

interface MarketingCampaignsStoreState {
    marketingCampaign: MarketingCampaign | null;
}

export const useMarketingCampaignStore = defineStore('MarketingCampaignStore', {
    state: (): MarketingCampaignsStoreState => ({
        marketingCampaign: null,
    }),
    actions: {
        async fetchMarketingCampaignData(
            routeName?: string,
            resourceAlias?: string,
            resourceSlug?: string,
            countryCode?: string,
        ) {
            const response = await fetchMarketingCampaignData(
                routeName,
                resourceAlias,
                resourceSlug,
                countryCode,
            );

            this.marketingCampaign = response.data;
        },
    },
});
